import isEmpty from 'lodash/isEmpty';
import { listWM } from 'utils/Api';

import * as types from 'constants/ActionTypes';

function requestCareer() {
  return {
    type: types.REQUEST_CAREER,
  };
}

function requestCareerSuccess(careerData) {
  return {
    type: types.REQUEST_CAREER_SUCCESS,
    careerData,
    receivedAt: Date.now(),
  };
}

function requestCareerFailure(error) {
  return {
    type: types.REQUEST_CAREER_FAILURE,
    error,
  };
}

export function fetchCareer() {
  return (dispatch, getState) => {
    dispatch(requestCareer());

    const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();

    const fetchConfig = {
      entity: 'EmployeeMasterCareer',
      headers: { Authorization: `Bearer ${token}` },
      params: {
        $filter: `Entity/EmployeeMasterID eq ${EmployeeMasterID}`,
      },
    };

    listWM(fetchConfig)
      .then(({ data }) => dispatch(requestCareerSuccess(data)))
      .catch(error => dispatch(requestCareerFailure(error)));
  };
}

export function fetchCareerIfNeeded() {
  return (dispatch, getState) =>
    isEmpty(getState().careerReducer.careerData) &&
    dispatch(fetchCareer());
}



// WEBPACK FOOTER //
// ./src/actions/career.js